<template>
  <div
    v-if="visible"
    class="alert alert-dark position-fixed top-0 end-0 alert-control"
    role="alert"
    style="z-index: 1050"
  >
    {{ message }}
  </div>
</template>

<script>
export default {
  props: ["visible", "message"],
};
</script>

<style scoped>
.alert-control {
  margin: 20px;
  width: 400px;
}
</style>
